export default __webpack_public_path__ + "img/952bdd66af73073b18d05d4c09b20870.png";